<app-pill 
    [text]="filterState.text" 
    [backgroundColor]="getColor(colorProp.FilterPillBackground)" 
    [closeable]="!disable.value" 
    (closeClickEvent)="onCloseClick()"
>
</app-pill>